/**
 * Routing callbacks — Voluum pill labels (flow name panel parity).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { VoluumRealtimeRoutingApi } from '@trafficpulse/shared';

import type { PathSettingPillOption } from '../../paths/settings/path-settings.constants';

export const ROUTING_CALLBACK_PILL_OPTIONS: PathSettingPillOption<VoluumRealtimeRoutingApi>[] =
  [
    {
      value: 'DISABLED',
      label: 'Disabled',
      description:
        'Routing callbacks are off for the whole flow (Voluum DISABLED).',
    },
    {
      value: 'ENABLED',
      label: 'Enabled',
      description:
        'Routing callbacks apply to the entire flow when your account supports them.',
    },
    {
      value: 'PATHS',
      label: 'Selected paths',
      description:
        'Routing callbacks only for paths you configure (Voluum PATHS mode).',
    },
  ];
